import { $ } from './../../helpers/query';
import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';

export default () => {

  $('.plans').each(section => {

    const accordions = $('.plan-info', section);
    const carousel = $('.plans__photos', section);

    const swiper = new Swiper(carousel.elem, {
      allowTouchMove: false,
      effect: 'fade',
      on: {
        init: () => {
          setActiveAccordion(accordions.elem);
        }
      }
    });

    accordions.on('click', (e, accordion) => {
      if ($(accordion).hasClass('plan-info--active')) {
        removeActiveAccordion(accordion);
      } else {
        accordions.each(item => {
          removeActiveAccordion(item);
        });
        setActiveAccordion(accordion);
        const index = $(accordion).getAttr('data-move-to') - 1;
        swiper.slideTo(index);
      }
    });

    function setActiveAccordion(item) {
      item.classList.add('plan-info--active');

      const text = $('.plan-info__description', item);
      text.css({ height: 'auto' });
      const fullHeight = text.height();
      gsap.fromTo(text.elem, {
        height: 0
      }, {
        height: fullHeight,
        duration: 0.3,
        ease: 'power2.out'
      });
    }

    function removeActiveAccordion(item) {
      item.classList.remove('plan-info--active');

      const text = $('.plan-info__description', item);
      gsap.to(text.elem, {
        height: 0,
        duration: 0.3,
        ease: 'power2.out'
      });
    }

  });

}
